import React from 'react';
import { currencyFormatter } from 'utils/formatter';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import { getCreatedAt } from './formatter';
import styles from './Table.css';

class Table extends React.Component {
  render() {
    const {
      transactions,
      transactionDetail,
    } = this.props.data.reports.transactions;
    return (
      <div className={styles['table-list']} id="transaction-table-list">
        {transactions.map((transaction, tidx) => {
          return (
            <table
              key={tidx}
              className={`table table-responsive ${styles.table} ${this.props.className}`}
            >
              <thead className={styles['table-head']}>
                <tr className="visible-md visible-lg">
                  <th colSpan="3">{transaction.date_label}</th>
                  <th colSpan="2" className="text-right">
                    <span>
                      {Number.isFinite(transaction.total_collected) &&
                        currencyFormatter(transaction.total_collected)}
                    </span>
                  </th>
                </tr>
                <tr className="visible-xs visible-sm">
                  <th>
                    {moment(transaction.date_label).format('ddd, MMM DD, YYYY')}
                  </th>
                  <th className="text-right">
                    <span>
                      {Number.isFinite(transaction.total_collected) &&
                        currencyFormatter(transaction.total_collected)}
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {transaction.payments.map((payment, pidx) => {
                  return (
                    <tr
                      key={pidx}
                      onClick={() => this._onClickRow(payment)}
                      className={`${styles['table-row']} ${
                        transactionDetail !== null &&
                        payment.parent_payment_id === transactionDetail.id
                          ? styles.selected
                          : ''
                      }`}
                    >
                      <td className="text-left visible-md visible-lg">
                        {payment.outlet_name}
                      </td>
                      <td>
                        <span>{getCreatedAt(payment.created_at)}</span>
                      </td>
                      <td className="text-left visible-md visible-lg">
                        {payment.created_by}
                      </td>
                      <td className="text-left visible-md visible-lg">
                        {payment.name}
                      </td>
                      <td className={`text-right ${styles.total}`}>
                        {!payment.is_refunded &&
                          (Number.isFinite(payment.total_collected) &&
                            currencyFormatter(payment.total_collected))}
                        {payment.is_refunded &&
                          (Number.isFinite(payment.refund_amount) &&
                            currencyFormatter(payment.refund_amount))}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          );
        })}
      </div>
    );
  }

  _onClickRow = payment => {
    this.props.onChangePayment(payment);
  };
}

Table.propTypes = {
  onChangePayment: PropTypes.func,
};

function mapStateToProps(state) {
  // only fetch some state
  return {
    data: {
      reports: {
        transactions: state.reports.transactions,
      },
    },
  };
}
export default connect(mapStateToProps)(Table);
